export default function Hero() {
  const stats = [
    { label: '每日更新', value: '200+', suffix: '部' },
    { label: '高清片库', value: '10万+', suffix: '部' },
    { label: '在线用户', value: '500万+', suffix: '人' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100 to-primary-50/30"></div>

      <div className="relative w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium tracking-wide mb-5">
              每日更新 · 热播推荐 · 高清无广告
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              丫丫影院
              <span className="block text-primary-600 mt-1">
                免费高清影视在线观看平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-3">
              不缓冲，不卡顿，最新电影电视剧全集一站畅享
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              丫丫影院汇聚全网热门影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全类型内容。每日同步更新最新院线大片与热播剧集，高清画质流畅播放，无需注册即可免费观看。无论您是追剧达人还是电影爱好者，这里都是您的最佳观影入口。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">
                    {stat.value}
                    <span className="text-sm md:text-base text-foreground-500 ml-0.5">{stat.suffix}</span>
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-primary-500 text-white font-medium text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>查看焦点专题
              </a>
              <a
                href="#topics"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-xl border-2 border-foreground-200 text-foreground-700 font-medium text-sm md:text-base hover:border-primary-400 hover:text-primary-600 transition-all duration-200 whitespace-nowrap text-center"
              >
                <i className="ri-fire-line mr-2"></i>浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-3xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20scene%20with%20warm%20red%20and%20gold%20ambient%20lighting%2C%20film%20projector%20beam%20cutting%20through%20darkness%2C%20luxurious%20velvet%20curtains%2C%20art%20deco%20architectural%20details%2C%20atmospheric%20and%20elegant%20composition%2C%20rich%20cinematic%20mood%2C%20deep%20shadows%20with%20dramatic%20highlights&width=800&height=600&seq=hero-movie-2026&orientation=landscape"
                  alt="丫丫影院电影主题视觉"
                  className="w-full h-auto object-cover aspect-[4/3]"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-accent-500 text-white rounded-xl px-5 py-3 flex items-center gap-2 shadow-lg">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-flashlight-line text-xl"></i>
                </div>
                <div>
                  <div className="text-xs opacity-80">实时在线</div>
                  <div className="text-sm font-bold">500万+ 用户</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}